export const auth_loading_status = "auth_loading_status";

export const auth_error_status = "auth_error_status";

export const auth_login_success_status = "auth_login_success_status";

export const auth_logout_success_status = "auth_logout_success_status";
